import React from 'react';

// tslint:disable:max-line-length

const LoyaltyMemberIcon: React.FC = () => (
    <svg viewBox="0 0 54.5 57.4" width="54.5" height="57.4">
        <path fill="none" stroke="currentColor" strokeWidth="2.126" strokeMiterlimit="10" d="M49.8,42.9c-1.6-1.5-9.5-4.7-12.6-5.9c-3.1-1.2-3.2-2.1-3.2-3.2v-3.5c0.3-0.4,0.5-0.8,0.7-1.2 c1.2-1.7,2.1-3.6,2.5-5.7c0.1-0.4,0.3-0.8,0.5-1.1c0.8-1.5,1.1-3.2,0.7-4.8c-0.2-0.9-0.2-1.7,0-2.6c0.1-0.8,0.2-1.6,0.2-2.5 c-0.1-4-1.9-7-5.6-8.6c-2.5-1.2-5.2-1.9-7.9-2.2c-1.2-0.1-2.3,0.1-3.4,0.6c-1.2,0.5-2.3,1.3-3.3,2.2C16.5,6,15,8.1,15,10.9 c0,1.3,0.1,2.5,0.1,3.8c0.2,1,0.1,2-0.2,3c-0.2,0.9-0.2,1.9,0.1,2.8c0.2,1,0.8,1.8,1.1,2.8c0.6,2.8,1.9,5.3,3.8,7.4l0,3.3 c0,1.2-0.1,2.1-3.1,3.3c-1.4,0.6-3.7,1.6-6.1,2.7c-2.8,1.3-5.5,2.7-6.3,3.5c-2.3,2.3-3,8.6-3,9.3c0,0.5,0.3,1,1,1.1 c2.5,0.7,10.9,2,24.8,1.8c14-0.2,22.3-1.8,24.8-2.5c0.7-0.2,1-0.7,1-1.2C53.1,51.5,52.2,45.1,49.8,42.9z"/>
    </svg>

);
export { LoyaltyMemberIcon };
